import React from 'react';
import { IconTypes } from 'models/types';
import { COLOR_PRIMARY, COLOR_ERROR, COLOR_SUCCESS, COLOR_LIGHT } from '../../../constants';

interface IconProps {
  type: IconTypes;
  width?: string;
  height?: string;
  color?: string;
}

const Icon: React.FC<IconProps> = ({ type, width, height = width, color = COLOR_PRIMARY }) => {
  switch (type) {
    case 'share':
      return (
        <svg
          width={!!width ? width : 8}
          height={!!height ? height : 8}
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_34_228)">
            <path
              d="M6.55433 0C5.75592 0 5.10868 0.647255 5.10868 1.44565C5.10868 1.47937 5.1114 1.5124 5.1138 1.54551L2.44328 2.79891C2.18377 2.55094 1.83289 2.39783 1.44566 2.39783C0.647254 2.39785 0 3.0451 0 3.84349C0 4.6419 0.647254 5.28914 1.44565 5.28914C1.69751 5.28914 1.93428 5.22443 2.14044 5.11124L3.29636 6.08525C3.24574 6.2326 3.21704 6.38995 3.21704 6.55435C3.21704 7.35276 3.86429 8 4.66269 8C5.46111 8 6.10833 7.35275 6.10833 6.55435C6.10833 5.75596 5.4611 5.1087 4.66269 5.1087C4.41084 5.1087 4.17408 5.17343 3.96788 5.28659L2.81197 4.3126C2.86261 4.16533 2.89129 4.0079 2.89129 3.84349C2.89129 3.80979 2.88858 3.77684 2.88619 3.74364L5.5567 2.49024C5.81621 2.7382 6.16708 2.89131 6.5543 2.89131C7.35269 2.89131 7.99994 2.24406 7.99994 1.44566C7.99994 0.647271 7.35272 0 6.55433 0Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_34_228">
              <rect width="7.99994" height="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'add-cross':
      return (
        <svg
          width={!!width ? width : 8}
          height={!!height ? height : 8}
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_36_136)">
            <path d="M4.75 0H3.25V8H4.75V0Z" fill={color} />
            <path d="M8 4.75V3.25L0 3.25V4.75H8Z" fill={color} />
          </g>
          <defs>
            <clipPath id="clip0_36_136">
              <rect width="8" height="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'check-case':
      return (
        <svg
          width={!!width ? width : 8}
          height={!!height ? height : 8}
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_36_383)">
            <g clipPath="url(#clip1_36_383)">
              <path
                d="M0.666667 0.666667C0.1 1.23333 0 1.76667 0 4C0 6.23333 0.1 6.76667 0.666667 7.33333C1.23333 7.9 1.76667 8 4 8C7.63333 8 8 7.63333 8 4C8 1.76667 7.9 1.23333 7.33333 0.666667C6.76667 0.0999994 6.23333 0 4 0C1.76667 0 1.23333 0.0999994 0.666667 0.666667ZM6.93333 1.06667C7.46667 1.6 7.46667 6.4 6.93333 6.93333C6.7 7.16667 5.53333 7.33333 4 7.33333C2.46667 7.33333 1.3 7.16667 1.06667 6.93333C0.533333 6.4 0.533333 1.6 1.06667 1.06667C1.6 0.533333 6.4 0.533333 6.93333 1.06667Z"
                fill={color}
              />
              <path
                d="M4.43331 3.73333C3.56665 4.6 3.29998 4.7 2.86665 4.36667C2.13331 3.73333 1.93331 4.5 2.66665 5.16667C3.33331 5.76667 3.39998 5.76667 4.66665 4.5C5.93331 3.23333 6.29998 2.66667 5.73331 2.66667C5.59998 2.66667 4.99998 3.13333 4.43331 3.73333Z"
                fill={color}
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_36_383">
              <rect width="7.99994" height="8" fill="white" />
            </clipPath>
            <clipPath id="clip1_36_383">
              <rect width="8" height="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'error':
      return (
        <svg
          width={!!width ? width : 16}
          height={!!height ? height : 17}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="0.5"
            width="16"
            height="16"
            rx="8"
            fill={color !== COLOR_PRIMARY ? color : COLOR_ERROR}
          />
          <path
            d="M7.484 10.432C7.42 10.432 7.376 10.424 7.352 10.408C7.336 10.392 7.328 10.34 7.328 10.252L7.136 5.08C7.136 5.024 7.144 4.984 7.16 4.96C7.176 4.936 7.212 4.924 7.268 4.924H8.696C8.784 4.924 8.828 4.972 8.828 5.068L8.624 10.252C8.624 10.332 8.616 10.384 8.6 10.408C8.584 10.424 8.532 10.432 8.444 10.432H7.484ZM8.708 12.556C8.708 12.764 8.656 12.924 8.552 13.036C8.456 13.148 8.248 13.204 7.928 13.204C7.648 13.204 7.444 13.148 7.316 13.036C7.196 12.924 7.136 12.764 7.136 12.556C7.136 12.348 7.196 12.192 7.316 12.088C7.444 11.976 7.648 11.92 7.928 11.92C8.248 11.92 8.456 11.976 8.552 12.088C8.656 12.192 8.708 12.348 8.708 12.556Z"
            fill="#F5F1EF"
          />
        </svg>
      );
    case 'success':
      return (
        <svg
          width={!!width ? width : 16}
          height={!!height ? height : 17}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            y="0.5"
            width="16"
            height="16"
            rx="8"
            fill={color !== COLOR_PRIMARY ? color : COLOR_SUCCESS}
          />
          <path d="M3.755 8.5L6.58501 11.33L12.245 5.67" stroke="#F5F1EF" strokeMiterlimit="10" />
        </svg>
      );
    case 'dot-menu':
      return (
        <svg
          width={!!width ? width : 11}
          height={!!height ? height : 3}
          viewBox="0 0 11 3"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_36_194)">
            <path
              d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
              fill={color}
            />
            <path
              d="M5.5 3C6.32843 3 7 2.32843 7 1.5C7 0.671573 6.32843 0 5.5 0C4.67157 0 4 0.671573 4 1.5C4 2.32843 4.67157 3 5.5 3Z"
              fill={color}
            />
            <path
              d="M9.5 3C10.3284 3 11 2.32843 11 1.5C11 0.671573 10.3284 0 9.5 0C8.67157 0 8 0.671573 8 1.5C8 2.32843 8.67157 3 9.5 3Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_36_194">
              <rect width="11" height="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'password-show':
      return (
        <svg
          width={!!width ? width : 12}
          height={!!height ? height : 9}
          viewBox="0 0 12 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_30_32)">
            <path
              d="M6.00004 7.78C9.01551 7.78 11.46 6.15032 11.46 4.14C11.46 2.12968 9.01551 0.5 6.00004 0.5C2.98456 0.5 0.540039 2.12968 0.540039 4.14C0.540039 6.15032 2.98456 7.78 6.00004 7.78Z"
              stroke={color}
              strokeMiterlimit="10"
            />
            <path
              d="M6.00007 5.81999C6.92791 5.81999 7.68007 5.06783 7.68007 4.13999C7.68007 3.21215 6.92791 2.45999 6.00007 2.45999C5.07223 2.45999 4.32007 3.21215 4.32007 4.13999C4.32007 5.06783 5.07223 5.81999 6.00007 5.81999Z"
              stroke={color}
              strokeMiterlimit="10"
            />
          </g>
          <defs>
            <clipPath id="clip0_30_32">
              <rect width="12" height="8.28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'password-hide':
      return (
        <svg
          width={!!width ? width : 12}
          height={!!height ? height : 10}
          viewBox="0 0 12 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_30_34)">
            <path
              d="M5.72727 8.24676C8.33807 8.24676 10.4545 6.83577 10.4545 5.09524C10.4545 3.35471 8.33807 1.94373 5.72727 1.94373C3.11647 1.94373 1 3.35471 1 5.09524C1 6.83577 3.11647 8.24676 5.72727 8.24676Z"
              stroke={color}
              strokeMiterlimit="10"
            />
            <path d="M1.83105 9L9.83105 1" stroke={color} strokeMiterlimit="10" />
          </g>
          <defs>
            <clipPath id="clip0_30_34">
              <rect width="12" height="9.94" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'logo':
      return (
        <svg
          width={!!width ? width : 16}
          height={!!height ? height : 18}
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="18" rx="4" fill="#def5ff" />
          <path d="M3 3H7V15H3V3Z" fill={color} />
          <path d="M9 3H13V11H9V3Z" fill={color} />
        </svg>
      );
    case 'github':
      return (
        <svg
          width={!!width ? width : 72}
          height={!!height ? height : 72}
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
              fill={color}
            />
            <path
              d="M35.9985,12 C22.746,12 12,22.7870921 12,36.096644 C12,46.7406712 18.876,55.7718301 28.4145,58.9584121 C29.6145,59.1797862 30.0525,58.4358488 30.0525,57.7973276 C30.0525,57.2250681 30.0315,55.7100863 30.0195,53.6996482 C23.343,55.1558981 21.9345,50.4693938 21.9345,50.4693938 C20.844,47.6864054 19.2705,46.9454799 19.2705,46.9454799 C17.091,45.4500754 19.4355,45.4801943 19.4355,45.4801943 C21.843,45.6503662 23.1105,47.9634994 23.1105,47.9634994 C25.2525,51.6455377 28.728,50.5823398 30.096,49.9649018 C30.3135,48.4077535 30.9345,47.3460615 31.62,46.7436831 C26.2905,46.1352808 20.688,44.0691228 20.688,34.8361671 C20.688,32.2052792 21.6225,30.0547881 23.1585,28.3696344 C22.911,27.7597262 22.0875,25.3110578 23.3925,21.9934585 C23.3925,21.9934585 25.4085,21.3459017 29.9925,24.4632101 C31.908,23.9285993 33.96,23.6620468 36.0015,23.6515052 C38.04,23.6620468 40.0935,23.9285993 42.0105,24.4632101 C46.5915,21.3459017 48.603,21.9934585 48.603,21.9934585 C49.9125,25.3110578 49.089,27.7597262 48.8415,28.3696344 C50.3805,30.0547881 51.309,32.2052792 51.309,34.8361671 C51.309,44.0917119 45.6975,46.1292571 40.3515,46.7256117 C41.2125,47.4695491 41.9805,48.9393525 41.9805,51.1877301 C41.9805,54.4089489 41.9505,57.0067059 41.9505,57.7973276 C41.9505,58.4418726 42.3825,59.1918338 43.6005,58.9554002 C53.13,55.7627944 60,46.7376593 60,36.096644 C60,22.7870921 49.254,12 35.9985,12"
              fill="#FFF"
            />
          </g>
        </svg>
      );
    case 'telegram':
      return (
        <svg
          width={!!width ? width : 512}
          height={!!height ? height : 512}
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Telegram"
          role="img"
          viewBox="0 0 512 512"
        >
          <rect width="512" height="512" rx="15%" fill={color} />
          <path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144" />
          <path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34" />
          <path
            fill="#f6fbfe"
            d="M204 319l135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width={!!width ? width : 64}
          height={!!height ? height : 64}
        >
          <path
            d="M29.63.001H2.362C1.06.001 0 1.034 0 2.306V29.69C0 30.965 1.06 32 2.362 32h27.27C30.937 32 32 30.965 32 29.69V2.306C32 1.034 30.937.001 29.63.001z"
            fill={color}
          />
          <path
            d="M4.745 11.997H9.5v15.27H4.745zm2.374-7.6c1.517 0 2.75 1.233 2.75 2.75S8.636 9.9 7.12 9.9a2.76 2.76 0 0 1-2.754-2.753 2.75 2.75 0 0 1 2.753-2.75m5.35 7.6h4.552v2.087h.063c.634-1.2 2.182-2.466 4.5-2.466 4.806 0 5.693 3.163 5.693 7.274v8.376h-4.743V19.84c0-1.77-.032-4.05-2.466-4.05-2.47 0-2.85 1.93-2.85 3.92v7.554h-4.742v-15.27z"
            fill="#FFF"
          />
        </svg>
      );
    case 'edit':
      return (
        <svg
          width={!!width ? width : 24}
          height={!!height ? height : 24}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      );
    case 'rss':
      return (
        <svg
          width={!!width ? width : 100}
          height={!!height ? height : 37.13}
          viewBox="0 0 150 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4_192)">
            <path
              d="M77.4421 19.8734L84.5785 19.3765C84.7413 20.6332 85.0398 21.5684 85.5282 22.2406C86.3151 23.2928 87.4005 23.8188 88.8386 23.8188C89.8969 23.8188 90.7381 23.5558 91.3079 23.0005C91.8506 22.5621 92.1762 21.8607 92.1762 21.1301C92.1762 20.4287 91.8777 19.7565 91.3622 19.3181C90.8195 18.792 89.5441 18.266 87.5362 17.7984C84.2529 17.0093 81.8922 15.9571 80.5083 14.6128C79.1245 13.3561 78.3376 11.5149 78.3918 9.55676C78.3918 8.21238 78.7717 6.86801 79.4772 5.75744C80.2912 4.50074 81.4038 3.50707 82.7334 2.95179C84.1715 2.2796 86.1795 1.92889 88.703 1.92889C91.7963 1.92889 94.157 2.54263 95.7851 3.79933C97.4132 5.0268 98.39 7.01413 98.6885 9.73211L91.6335 10.1705C91.4436 9.00147 91.0637 8.15393 90.4396 7.59865C89.8155 7.04336 89.0014 6.78033 87.9432 6.78033C87.0749 6.78033 86.4237 6.98491 85.9895 7.36484C85.5825 7.71555 85.3111 8.24161 85.3383 8.82612C85.3383 9.2645 85.5554 9.67366 85.881 9.93669C86.2337 10.2874 87.0749 10.6089 88.4045 10.9011C91.6878 11.661 94.0213 12.4209 95.4595 13.2099C96.8976 13.999 97.9287 14.9635 98.5528 16.1033C99.2041 17.2723 99.5297 18.6167 99.5025 19.9903C99.5025 21.6269 99.0684 23.2635 98.2001 24.6371C97.3046 26.0692 96.0564 27.1797 94.5912 27.8519C93.0445 28.5826 91.0908 28.9625 88.7572 28.9625C84.6328 28.9625 81.7836 28.115 80.1827 26.3907C78.5818 24.6664 77.6321 22.5037 77.4421 19.8734ZM1.70948 28.5241V2.3965H14.2185C16.525 2.3965 18.3158 2.60108 19.5369 3.03946C20.7308 3.44862 21.7891 4.29616 22.4946 5.43596C23.2815 6.69265 23.6614 8.15393 23.6342 9.67366C23.7156 12.2455 22.4946 14.7004 20.4052 15.9864C19.5912 16.4832 18.6957 16.8339 17.7732 17.0093C18.4515 17.2138 19.1299 17.5646 19.7268 17.9737C20.1881 18.3829 20.568 18.8505 20.9208 19.3473C21.3278 19.8441 21.6805 20.3994 21.979 20.9839L25.6151 28.5533H17.0948L13.0789 20.5163C12.5633 19.4934 12.1292 18.8212 11.7221 18.4998C11.1795 18.0906 10.5282 17.886 9.87699 17.886H9.22576V28.4949H1.70948V28.5241ZM9.22576 12.9761H12.4005C13.0789 12.9177 13.7301 12.8008 14.3813 12.6254C14.8698 12.5378 15.3039 12.2455 15.6024 11.8071C16.335 10.755 16.2265 9.2645 15.331 8.35851C14.8426 7.92013 13.8929 7.68632 12.5362 7.68632H9.22576V12.9761ZM0 50.9109L7.1364 50.414C7.2992 51.6707 7.59768 52.606 8.08611 53.2781C8.84588 54.3303 9.95839 54.8855 11.3965 54.8855C12.4548 54.8855 13.2959 54.6225 13.8658 54.0672C14.4085 53.5996 14.7341 52.9274 14.7341 52.1968C14.7341 51.4954 14.4356 50.8232 13.92 50.3848C13.3774 49.8588 12.102 49.3327 10.0669 48.8651C6.78365 48.076 4.42294 47.0239 3.03907 45.6795C1.65521 44.4228 0.868307 42.5816 0.922576 40.6235C0.922576 39.2791 1.30246 37.9347 2.00796 36.8242C2.822 35.5675 3.93452 34.5738 5.26411 34.0185C6.70224 33.3463 8.7102 32.9956 11.2337 32.9956C14.3271 32.9956 16.6878 33.6094 18.3158 34.8661C19.9439 36.1228 20.8936 38.0809 21.1921 40.7988L14.1371 41.2372C13.9472 40.0682 13.5673 39.2207 12.9432 38.6654C12.3462 38.1101 11.5051 37.8471 10.4468 37.8763C9.57851 37.8763 8.92728 38.0809 8.49313 38.49C8.05897 38.8407 7.81476 39.3668 7.8419 39.9513C7.8419 40.3897 8.05897 40.7988 8.38459 41.0619C8.73734 41.4126 9.57851 41.7341 10.9081 42.0263C14.1914 42.7862 16.525 43.546 17.9631 44.3351C19.4012 45.1242 20.4323 46.0887 21.0564 47.2285C21.7077 48.3975 22.0333 49.7419 22.0333 51.0862C22.0333 52.7229 21.572 54.3303 20.7308 55.7039C19.8354 57.1359 18.5872 58.2465 17.1219 58.9187C15.5753 59.6493 13.6216 60.0292 11.288 60.0292C7.16353 60.0292 4.3144 59.1817 2.71346 57.4574C1.11252 55.7039 0.217077 53.5412 0 50.9109H0Z"
              fill={color}
            />
            <path
              d="M36.089 48.8651L42.6556 50.9985C42.3028 52.7813 41.5702 54.4764 40.5662 55.9669C39.6436 57.282 38.4226 58.3049 37.0387 58.9771C35.6277 59.6493 33.8368 60 31.666 60C29.034 60 26.8632 59.5908 25.208 58.7725C23.5257 57.9542 22.0875 56.4929 20.8665 54.4179C19.6454 52.3429 19.0485 49.6834 19.0485 46.4393C19.0485 42.114 20.1067 38.7823 22.2503 36.4734C24.394 34.1646 27.4059 32.9956 31.3133 32.9956C34.3795 32.9956 36.7673 33.6678 38.5311 34.9829C40.2677 36.3273 41.5702 38.3731 42.4385 41.1203L35.8176 42.6985C35.6548 42.0847 35.4106 41.471 35.085 40.9449C34.678 40.3312 34.1624 39.8636 33.5383 39.5129C32.9142 39.1622 32.2087 39.0161 31.5032 39.0161C29.7938 39.0161 28.4913 39.7467 27.5959 41.2372C26.9175 42.3185 26.5647 44.0429 26.5647 46.3809C26.5647 49.2742 26.9718 51.2616 27.7858 52.3429C28.5998 53.4242 29.7395 53.9503 31.2319 53.9503C32.67 53.9503 33.7554 53.5119 34.488 52.6644C35.2207 51.7584 35.7634 50.5017 36.089 48.8651ZM51.42 33.434H58.9092V42.5816H67.1038V33.434H74.6472V59.5616H67.1038V48.982H58.9092V59.5616H51.42V33.434Z"
              fill={color}
            />
            <path
              d="M73.6161 46.4978C73.6161 42.2309 74.7287 38.8991 76.9266 36.5319C79.1245 34.1646 82.2178 32.9664 86.1523 32.9664C90.1954 32.9664 93.2887 34.1354 95.4866 36.4734C97.6845 38.8115 98.7699 42.0847 98.7699 46.2932C98.7699 49.3619 98.2815 51.8461 97.3318 53.8042C96.4092 55.7331 94.9711 57.3112 93.2073 58.3633C91.3893 59.4447 89.1371 60 86.4508 60C83.7102 60 81.4581 59.5324 79.6672 58.5972C77.822 57.6035 76.3025 56.0545 75.2985 54.1549C74.186 52.1091 73.6161 49.5665 73.6161 46.4978ZM81.1053 46.527C81.1053 49.1573 81.5666 51.057 82.462 52.226C83.3575 53.3658 84.6057 53.9503 86.1795 53.9503C87.7804 53.9503 89.0286 53.395 89.924 52.2552C90.8195 51.1154 91.2536 49.0989 91.2536 46.1763C91.2536 43.7214 90.7924 41.9094 89.8698 40.7988C88.9472 39.659 87.699 39.1037 86.1252 39.1037C84.7413 39.0453 83.4117 39.6882 82.4892 40.828C81.5666 41.9678 81.1053 43.8675 81.1053 46.527ZM106.449 46.4978C106.449 42.2309 107.562 38.8991 109.759 36.5319C111.957 34.1646 115.051 32.9664 118.985 32.9664C123.028 32.9664 126.149 34.1354 128.319 36.4734C130.49 38.8115 131.603 42.0847 131.603 46.2932C131.603 49.3619 131.114 51.8461 130.165 53.8042C129.242 55.7331 127.804 57.3112 126.04 58.3633C124.222 59.4447 121.97 60 119.284 60C116.543 60 114.291 59.5324 112.5 58.5972C110.655 57.6035 109.135 56.0545 108.131 54.1549C107.019 52.1091 106.449 49.5665 106.449 46.4978ZM113.938 46.527C113.938 49.1573 114.399 51.057 115.295 52.226C116.19 53.3658 117.439 53.9503 119.012 53.9503C120.613 53.9503 121.861 53.395 122.757 52.2552C123.652 51.1154 124.086 49.0989 124.086 46.1763C124.086 43.7214 123.625 41.9094 122.703 40.7988C121.78 39.659 120.532 39.1037 118.958 39.1037C117.574 39.0453 116.217 39.6882 115.322 40.828C114.399 41.9678 113.938 43.8675 113.938 46.527Z"
              fill={color}
            />
            <path
              d="M130.816 33.434H138.305V53.132H150V59.5616H130.789V33.434H130.816Z"
              fill={color}
            />
            <path
              d="M122.561 31.9262C130.101 25.8063 132.426 15.4323 127.754 8.75499C123.083 2.07774 113.183 1.62585 105.643 7.74567C98.103 13.8655 95.7779 24.2396 100.45 30.9168C105.122 37.5941 115.021 38.046 122.561 31.9262Z"
              fill={COLOR_LIGHT}
              stroke={COLOR_PRIMARY}
              strokeWidth="1"
              strokeMiterlimit="10"
            />
            <path
              d="M106.476 17.9152L109.19 15.8695L112.527 20.9839C113.097 21.8022 113.531 22.679 113.857 23.6435C114.047 24.3741 113.992 25.1632 113.721 25.8646C113.368 26.7414 112.798 27.472 112.039 27.9981C111.143 28.6702 110.384 29.0502 109.732 29.1671C109.108 29.284 108.457 29.1671 107.86 28.8748C107.209 28.5241 106.639 28.0273 106.205 27.3843L108.538 25.0463C108.728 25.3678 108.973 25.66 109.244 25.8938C109.434 26.0399 109.651 26.1276 109.895 26.1276C110.085 26.1276 110.275 26.0399 110.411 25.923C110.682 25.7477 110.872 25.397 110.845 25.0463C110.763 24.5494 110.573 24.0526 110.275 23.6727L106.476 17.9152ZM114.616 21.1593L117.086 19.055C117.357 19.4057 117.71 19.6688 118.09 19.8149C118.632 19.9903 119.202 19.8734 119.664 19.4934C119.989 19.2596 120.26 18.9381 120.369 18.529C120.532 18.0029 120.26 17.4184 119.772 17.2431C119.691 17.2138 119.609 17.1846 119.528 17.1846C119.202 17.1554 118.632 17.3015 117.791 17.6814C116.407 18.2952 115.322 18.529 114.508 18.4413C113.721 18.3536 112.988 17.9152 112.554 17.1846C112.229 16.6878 112.066 16.1033 112.039 15.5188C112.039 14.8466 112.202 14.1744 112.554 13.6191C113.07 12.83 113.694 12.1578 114.454 11.6318C115.593 10.7842 116.597 10.3751 117.466 10.3751C118.334 10.3751 119.148 10.8134 119.908 11.7194L117.466 13.7944C116.977 13.1223 116.055 12.9761 115.431 13.5022L115.349 13.5899C115.078 13.7652 114.888 14.0283 114.779 14.3497C114.698 14.5835 114.752 14.8466 114.888 15.0511C114.996 15.1973 115.159 15.3142 115.349 15.3142C115.566 15.3434 115.946 15.2265 116.489 14.9635C117.846 14.3497 118.877 13.999 119.582 13.8821C120.179 13.7652 120.803 13.8237 121.373 14.0867C121.889 14.3205 122.323 14.7297 122.621 15.2265C123.001 15.811 123.218 16.5124 123.245 17.2431C123.272 18.0029 123.082 18.7336 122.703 19.3765C122.214 20.1656 121.59 20.8378 120.857 21.3639C119.365 22.4744 118.144 22.942 117.167 22.7667C116.109 22.5913 115.241 22.0068 114.616 21.1593Z"
              fill={COLOR_PRIMARY}
            />
          </g>
          <defs>
            <clipPath id="clip0_4_192">
              <rect width="150" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'confirm':
      return (
        <svg
          width={!!width ? width : 24}
          height={!!height ? height : 24}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill={color}
        >
          <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z" />
        </svg>
      );
    case 'cancel':
      return (
        <svg
          width={!!width ? width : 24}
          height={!!height ? height : 24}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill={color}
        >
          <path d="M4.293,18.293,10.586,12,4.293,5.707A1,1,0,0,1,5.707,4.293L12,10.586l6.293-6.293a1,1,0,1,1,1.414,1.414L13.414,12l6.293,6.293a1,1,0,1,1-1.414,1.414L12,13.414,5.707,19.707a1,1,0,0,1-1.414-1.414Z" />
        </svg>
      );
    case 'delete':
      return (
        <svg
          width={!!width ? width : 48}
          height={!!height ? height : 48}
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path d="M42,3H28a2,2,0,0,0-2-2H22a2,2,0,0,0-2,2H6A2,2,0,0,0,6,7H42a2,2,0,0,0,0-4Z" />
          <path d="M39,9a2,2,0,0,0-2,2V43H11V11a2,2,0,0,0-4,0V45a2,2,0,0,0,2,2H39a2,2,0,0,0,2-2V11A2,2,0,0,0,39,9Z" />
          <path d="M21,37V19a2,2,0,0,0-4,0V37a2,2,0,0,0,4,0Z" />
          <path d="M31,37V19a2,2,0,0,0-4,0V37a2,2,0,0,0,4,0Z" />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
